export enum TableView {
  MANAGER = 'manager',
  SALESPERSON = 'salesperson',
  EXECUTIVE = 'executive',
}
